import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "breadcrumbs",
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1)
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_7 = {
  key: 1,
  class: "breadcrumb-item"
}
const _hoisted_8 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_9 = {
  key: 1,
  class: "breadcrumb-item active",
  "aria-current": "page"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          href: '/' + _ctx.$route.params.catalog
        }, _toDisplayString(_ctx.catalogName), 9, _hoisted_5)
      ]),
      (_ctx.brand && _ctx.breadcrumbs.length == 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_ctx.brand.name), 1))
        : (_ctx.brand)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: {name: 'brand', params: {brand: _ctx.brand.id}}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.brand.name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (b) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: b.path
        }, [
          (!b.last)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: {name: 'category', params: {category: b.categories}}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(b.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(b.name), 1))
        ], 64))
      }), 128))
    ])
  ]))
}